<template>
  <section class="Page" :style="{ height: pageHeight }">
    <Header class="Page__header" :showServiceMenu="false" />
    <main class="Page__main">
      <GlobalNavigation
        class="Page__globalNavigation"
        :globalMenuItems="globalMenuItems"
      />
      <ScrollBox class="Page__scrollBox">
        <Inquiry :subject="subject"></Inquiry>
      </ScrollBox>
    </main>
  </section>
</template>

<script lang="ts">
export default {
  name: 'Others',
};
</script>

<script lang="ts" setup>
import { computed } from 'vue';
import ScrollBox from '@spectee/components/Atoms/ScrollBox/index.vue';
import GlobalNavigation from '@spectee/components/Organisms/GlobalNavigation/index.vue';
import { globalMenuItems } from '../../../data/SideMenuItems';
import Header from '@spectee/components/Organisms/Header/index.vue';
import Inquiry from '@spectee/components/Organisms/Inquiry/index.vue';
import { useWindowHeight } from '@spectee/composables/useWindowHeight';
import { inquiryNavigationSource } from '@admin/ts/store';
import messages from '../../../messages.json';

const { pageHeight } = useWindowHeight();

const subject = computed(() => {
  if (inquiryNavigationSource.value === 'menu') {
    return '';
  } else {
    inquiryNavigationSource.value = 'menu';
    return messages.inquiry.license;
  }
});
</script>

<style lang="scss" scoped>
@use '@spectee/assets/scss/_pageForward.scss' as *;

$margin-horizontal: $service-unit * 6;

.Page {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 100%;
  min-width: $service-unit * 75;

  & &__scrollBox {
    flex: 1;
    overflow: hidden;
    height: 100%;
    min-height: 0;
  }

  &__main {
    top: $service-unit * 12;
    position: relative;
    display: flex;
    flex: 1;
    height: 100%;
    overflow: hidden;
    padding: 0;
  }

  & &__globalNavigation {
    position: relative;
    top: 0;
    height: 100%;
  }

  @media (max-width: 767px) {
    &__main {
      padding-left: $service-unit * 8;
    }

    & &__globalNavigation {
      position: absolute;
      z-index: 1;
    }
  }
}
</style>
